import styled from 'styled-components';

export const Component = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

